import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41cc9fe0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "searchBar" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "hidden" }, "분류 및 검색바", -1))
const _hoisted_3 = { class: "search-bar" }
const _hoisted_4 = { class: "input-item select-category" }
const _hoisted_5 = {
  key: 0,
  class: "options-wrap"
}
const _hoisted_6 = { class: "options" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "input-item search-word" }

import { ref, watch } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchBar',
  props: {
  searchTypes: {
    type: Array,
    required: true,
  },
},
  emits: ['onClick_searchButton', 'setSearchType'],
  setup(__props, { emit }) {

const props = __props;



/**** data -------------------- */
var isOn_categorySelect = ref(false);
var isOn_search = ref(false);
var searchWord = ref('');
var seletedOption = ref('분류');
/**** methods ----------------- */
const onClick_categorySelect = () => {
  if (isOn_categorySelect.value) {
    isOn_categorySelect.value = false;
  } else {
    isOn_categorySelect.value = true;
  }
};
const onClick_searchButton = () => {
  isOn_categorySelect.value = false;
  emit('onClick_searchButton', searchWord.value);
};
const onClick_bg = () => {
  isOn_categorySelect.value = false;
};
const onClick_option = (item: { code: string; name: string }) => {
  seletedOption.value = item.name;
  emit('setSearchType', item);
  isOn_categorySelect.value = false;
};
/**** content -----------------
 * 분류 및 검색바
 * /
 */
/**** hook -------------------- */
watch(
  () => searchWord.value,
  (newValue, oldValue) => {
    // console.log(newValue);
  },
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(isOn_categorySelect))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "selector-bg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_bg()))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["option-default", [{ on: _unref(isOn_categorySelect) === true }, { selected: _unref(seletedOption) !== '분류' }]]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (onClick_categorySelect()))
        }, _toDisplayString(_unref(seletedOption)), 3),
        _createVNode(_Transition, { name: "selectOption" }, {
          default: _withCtx(() => [
            (_unref(isOn_categorySelect))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("ul", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.searchTypes, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "option-list",
                        key: item,
                        onClick: ($event: any) => (onClick_option(item))
                      }, _toDisplayString(item.name), 9, _hoisted_7))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          class: "input-search",
          type: "search",
          name: "searchWord",
          id: "searchWord",
          placeholder: "검색어 입력",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchWord) ? (searchWord).value = $event : searchWord = $event))
        }, null, 512), [
          [_vModelText, _unref(searchWord)]
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(["btn-search", [{ on: _unref(isOn_search) }]]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (onClick_searchButton()))
        }, "검색", 2)
      ])
    ])
  ]))
}
}

})